// The purpose of this module is to keep a list of visited MPCs in the session storage,
// in order to send the parentCommunityId for events only if the mpc parent of a listing
// was already visited during the current session.

(function mpcEventsHelper(global) {
  'use strict';

  // dependencies
  if (!global.NewHomeSource && !global.NewHomeSource.WebStorageHandler) {
    return false;
  }

  global.NewHomeSource = global.NewHomeSource || {};

  const previousModule = global.NewHomeSource.MpcEventsHelper;

  /**
   * @constructs NewHomeSource.MpcEventsHelper
   */
  function MpcEventsHelper() {
  }

  /**
   * @public
   * Adds the mpc id to a list of visited mpcs in the session storage
   */
  MpcEventsHelper.setVisitedMpc = function () {
    const mpcIdElement = document.querySelector('[data-mpc-id]');

    if (mpcIdElement) {
      let mpcId = parseInt(mpcIdElement.value, 10);

      // adds the mpcId to a list of visited MPCs in the session storage,
      // if the list exists, checks if the id is not already in the list
      let visitedMpcIds = global.NewHomeSource.WebStorageHandler.getSessionStorageItem('visitedMpcIds');

      if (!visitedMpcIds) {
        visitedMpcIds = [mpcId];
        global.NewHomeSource.WebStorageHandler.setSessionStorageItem('visitedMpcIds', visitedMpcIds);
      } else if (visitedMpcIds.indexOf(mpcId) === -1) {
        visitedMpcIds.push(mpcId);
        global.NewHomeSource.WebStorageHandler.setSessionStorageItem('visitedMpcIds', visitedMpcIds);
      }
    }
  };

  /**
   * @public
   * Checks if a mpc id is already in the visited list in the session storage
   * @param {number} mpcId
   * @returns True if the mpcId was visited, false otherwise.
   */
  MpcEventsHelper.isVisitedMpc = function (mpcId) {
    let id = mpcId;

    // in case of receiving a number as a string, converts it to number
    if (typeof id === 'string' && !window.isNaN(id)) {
      id = parseInt(mpcId, 10);
    }

    const visitedMpcIds = global.NewHomeSource.WebStorageHandler.getSessionStorageItem('visitedMpcIds');

    if (visitedMpcIds && visitedMpcIds.indexOf(id) !== -1) {
      return true;
    }

    return false;
  };

  /**
   * @public
   * noConflict: Returns control of NewHomeSource.SampleModule to the previous script.
   */
  MpcEventsHelper.noConflict = function noConflict() {
    global.NewHomeSource.MpcEventsHelper = previousModule;
    return MpcEventsHelper;
  };

  global.NewHomeSource.MpcEventsHelper = MpcEventsHelper;

  MpcEventsHelper.setVisitedMpc();

  return MpcEventsHelper;
}(window));
